import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface CalendarLegendItem {
  label: string;
  swatchStyle: string;
}

/**
 * Default event-type legend entries, matching the colors used by
 * `mapApiToCalendarEvents` for Assenza/Turno/Riunione/Promemoria/Prestazione,
 * plus the holiday pattern used by `siat-calendar`. Shared by every consumer
 * that shows this same set of event types, so the colors are defined once.
 */
export const DEFAULT_CALENDAR_LEGEND_ITEMS: CalendarLegendItem[] = [
  {
    label: 'Assenza',
    swatchStyle: `background: repeating-linear-gradient(
      45deg,
      #ffffff,
      #ffffff 4px,
      #f3f4f6 4px,
      #f3f4f6 8px
    ); border: 2px solid #4b5563;`,
  },
  {
    label: 'Turno',
    swatchStyle: 'background-color: #f0fdf4; border: 2px solid #16a34a',
  },
  {
    label: 'Riunione',
    swatchStyle: 'background-color: #fdf4ff; border: 2px solid #d946ef',
  },
  {
    label: 'Promemoria',
    swatchStyle: 'background-color: #fff7ed; border: 2px solid #ea580c',
  },
  {
    label: 'Prestazione',
    swatchStyle: 'background-color: #294a63',
  },
  {
    label: 'Prestazione erogata',
    swatchStyle: 'background-color: #f5dddd; border: 2px solid #0284c7',
  },
  {
    label: 'Tragitto',
    swatchStyle: 'background-color: #f1f5f9; border: 2px solid #94a3b8',
  },
  {
    label: 'Macchinario',
    swatchStyle: 'background-color: #ede7f6; border: 2px solid #6a1b9a',
  },
  {
    label: 'Festivo',
    swatchStyle: `background: repeating-linear-gradient(
      135deg,
      #fef3c7,
      #fef3c7 4px,
      #f59e0b 4px,
      #f59e0b 6px
    );`,
  },
];

/**
 * Small icon button that reveals a calendar's event-type legend in a
 * click-triggered popover, instead of an always-visible inline block. Every
 * calendar page supplies its own entries via `items`, so the legend content
 * stays page-specific while the toggle/popover behavior is shared.
 */
@Component({
  selector: 'siat-calendar-legend',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule],
  templateUrl: './calendar-legend.component.html',
})
export class CalendarLegendComponent {
  /*
   * The legend entries to display (label + swatch style).
   */
  readonly items = input.required<CalendarLegendItem[]>();
}
